export default "__VITE_ASSET__5f1222bc__"